import { instance } from './axios.instance'
import { TUTOR_ENDPOINT } from './endpoints'

/**
 * 강사정보 상세
 * GET /api/tutor/{id}
 * @param {string} id
 */
export const getTutorDetail = id => instance.get(TUTOR_ENDPOINT.DETAIL(id))

/**
 * 강사정보 삭제
 * DELETE /api/tutor/{id}
 * @param {string} id
 */
export const deleteTutor = id => instance.delete(TUTOR_ENDPOINT.DELETE(id))

/**
 * 강사정보 수정
 * PATCH /api/tutor/{id}
 * @param {Object} data
 */
export const editTutor = (id, data) => instance.patch(TUTOR_ENDPOINT.EDIT(id), data)

/**
 * 강사정보 등록
 * POST /api/tutor/create
 * @param {Object} data
 */
export const createTutor = data => instance.post(TUTOR_ENDPOINT.CREATE, data)

/**
 * 강사정보 목록
 * GET /api/tutor/list
 * @param {Object} params
 */
export const getTutorList = params => instance.get(TUTOR_ENDPOINT.LIST, { params })

/**
 * 지역별 강사정보 목록
 * GET /api/tutor/list/region
 */
export const getTutorRegionList = () => instance.get(TUTOR_ENDPOINT.LIST_REGION)

/**
 * 강사 유효성 검사
 * POST /api/tutor/valid
 * @param {Object} data
 * @param {string[]} data.tutorName
 * @param {number[]} data.registrationYear
 */
export const validTutor = ({ tutorName, registrationYear }) =>
    instance.post(TUTOR_ENDPOINT.VALID, { tutorName, registrationYear })
